import { render, staticRenderFns } from "./kw_image_canvas.vue?vue&type=template&id=480ae396&scoped=true&"
import script from "./kw_image_canvas.vue?vue&type=script&lang=js&"
export * from "./kw_image_canvas.vue?vue&type=script&lang=js&"
import style0 from "./kw_image_canvas.vue?vue&type=style&index=0&id=480ae396&scoped=true&lang=css&"
import style1 from "./kw_image_canvas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ae396",
  null
  
)

component.options.__file = "kw_image_canvas.vue"
export default component.exports